angular.module('property-price-list')
    .component('propertyPriceList', {
        bindings: {
            statistics: '<',
            filters: '<',
            page: '<'
        },
        templateUrl: 'app/property-price-list/list.html',
        controller: function ($scope, $state, $stateParams, PropertyPriceList, PropertyPriceListService) {
            this.reset = () => this.filters = {};
            this.PropertyPriceListService = PropertyPriceListService;

            $scope.$on('property-price-list.updated', () => $state.reload());
        }
    })
